<template>
  <div>
    <van-search
      v-model="value"
      label="产品"
      placeholder="请输入两字以上关键词搜索产品"
      input-align="center"
      show-action
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="query">
      <van-cell v-for="item in data" :key="item.id" :title="item.name" @click="handleClick(item)">
        <template>
          ¥ {{ item.base_price | toThousandFilter }}
        </template>
        <template #label>
          <van-tag v-if="item.type_names" plain type="danger">{{ item.type_names }}</van-tag>
          <van-tag v-if="item.specs" plain type="primary">{{ item.specs }}</van-tag>
        </template>
      </van-cell>
    </van-pull-refresh>
    <van-col v-if="data.length === 0" :span="24" style="text-align: center; font-size: 14px; color: gray;">
      {{ CONST.EMPTY_MSG }}
    </van-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BaseSearchGoodsList',
  data() {
    return {
      loading: false,
      data: [],
      value: '',
      keywords: '',
      goodsTypeMap: new Map()
    }
  },
  computed: {
    ...mapGetters(['goodsTypeList', 'goodsDataForSales', 'goodsMapOfNamesArray', 'goodsMapOfId'])
  },
  mounted() {
    this.goodsTypeMap.clear()
    this.Utils.setTreeData(this.goodsTypeList, (row) => {
      this.goodsTypeMap.set(row.id, row)
    })
  },
  methods: {
    query() {
      this.loading = true
      this.data = []
      this.Utils.setTreeData(this.goodsDataForSales, (row) => {
        if (!row.children) {
          const goods = this.goodsMapOfId[row.id]
          if (goods && goods.status === this.CONST.STATUS.find(status => status.name === '启用').id) {
            const goodsType = this.goodsTypeMap.get(goods.type_id)
            if (goodsType && goodsType.is_sell === 1 &&
                (goods.name.indexOf(this.keywords) !== -1 ||
                goods.code.indexOf(this.keywords) !== -1)) {
              const namesArray = this._.cloneDeep(this.goodsMapOfNamesArray[goods.id])
              namesArray.pop()
              goods.type_names = namesArray.join(' / ')
              this.data.push(goods)
            }
          }
        }
      })
      this.loading = false
    },
    onSearch() {
      this.keywords = this.value.trim()
      if (this.keywords && this.keywords.length >= 2) {
        this.query()
      } else {
        this.toast('请您至少输入两个字进行检索')
      }
    },
    handleClick(item) {
      this.$emit('change', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseSearchGoodsList.vue